import React, { createContext, useContext, useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=unauth, obj=auth

  useEffect(() => {
    const token = localStorage.getItem("vsm_token");
    if (!token) { setUser(null); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("vsm_token"); setUser(null); });
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("vsm_token", data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiError(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("vsm_token");
    setUser(null);
    window.location.href = "/login";
  };

  const isSuperAdmin = user?.role === "super_admin";
  const isReadOnly = user?.role === "client_admin";

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, isSuperAdmin, isReadOnly }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
